import { render, staticRenderFns } from "./WebTradingTerminalPage.vue?vue&type=template&id=7e4e21f2&scoped=true"
import script from "./WebTradingTerminalPage.vue?vue&type=script&lang=js"
export * from "./WebTradingTerminalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4e21f2",
  null
  
)

export default component.exports